import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteStepMutation} from '../hooks/useStepsQuery';
import {useStepsSelection} from "../hooks/useStepsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteStepMutation = useDeleteStepMutation();

    const {
        selection,
        handleClearSelection,
    } = useStepsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteStepMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
